import React, { useState, useEffect } from 'react';
import { Plus, Loader2, Award } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { getProducts } from '../services/api';

const ProductsSection = () => {
  const { addToCart } = useCart();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const data = await getProducts();
        setProducts(data);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching products:', err);
        setError('Greška pri učitavanju proizvoda');
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  const handleAddToCart = (product) => {
    addToCart(product);
  };

  if (loading) {
    return (
      <section id="products" className="products-section">
        <div className="section-container">
          <div className="section-header">
            <h2 className="section-title">NAŠI PROIZVODI</h2>
            <p className="section-subtitle">Učitavanje...</p>
          </div>
          <div className="loading-container">
            <Loader2 size={48} className="loading-spinner" />
          </div>
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section id="products" className="products-section">
        <div className="section-container">
          <div className="section-header">
            <h2 className="section-title">NAŠI PROIZVODI</h2>
            <p className="section-subtitle error">{error}</p>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section id="products" className="products-section">
      <div className="section-container">
        <div className="section-header">
          <h2 className="section-title">NAŠI PROIZVODI</h2>
          <p className="section-subtitle">
            Izaberite savršenu veličinu za vaše potrebe
          </p>
        </div>

        <div className="products-grid">
          {products.map((product) => (
            <div key={product.id} className="product-card">
              <div className="product-image-wrapper">
                {product.is_bestseller && (
                  <div className="bestseller-badge">
                    <Award size={12} style={{ marginRight: 4 }} />
                    Najprodavaniji
                  </div>
                )}
                <img
                  src={product.image}
                  alt={`${product.name} ${product.size}`}
                  className="product-image"
                />
                <div className="product-size-badge">{product.size}</div>
              </div>
              
              <div className="product-info">
                <h3 className="product-name">{product.name}</h3>
                <p className="product-size-text">{product.size}</p>
                <p className="product-description">{product.description}</p>
                
                <div className="product-footer">
                  <div className="product-price-wrapper">
                    <span className="product-price">
                      {product.price.toLocaleString('sr-RS')} RSD
                    </span>
                    <span className="product-shipping-note">+ Troškovi dostave 350 RSD</span>
                  </div>
                  <button
                    className="add-to-cart-btn"
                    onClick={() => handleAddToCart(product)}
                    aria-label={`Dodaj ${product.name} u korpu`}
                  >
                    <Plus size={18} />
                    Dodaj
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductsSection;
